import { ComponentDataDestService } from '../component-data-dest.service';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { environment } from '../../../environment/environment';
import { Observable } from 'rxjs';

/**
 * Update organization settings. Merges payload.data into the organization's data column only.
 * Does not modify the org_name column (use a separate flow if that is ever needed).
 * Payload: { organizationId: number, data: Record<string, unknown> }
 * Also accepts organization_id and org_id as aliases for organizationId.
 */
export function update_org_settings(
  componentDataDestService: ComponentDataDestService,
  _componentDataSourceService: ComponentDataSourceService,
  data: {
    organizationId?: number;
    organization_id?: number;
    org_id?: number;
    data: Record<string, unknown>;
  }
): Observable<unknown> {
  const orgId = data.organizationId ?? data.organization_id ?? data.org_id;
  if (orgId == null) {
    return new Observable((obs) => obs.error(new Error('organizationId is required')));
  }
  const id = typeof orgId === 'number' ? orgId : parseInt(String(orgId), 10);
  if (!data.data || typeof data.data !== 'object') {
    return new Observable((obs) => obs.error(new Error('data object is required')));
  }
  const body = { data: data.data };
  return componentDataDestService.http.patch(
    `${environment.apiUrl}/organizations/${id}`,
    body,
    { withCredentials: true }
  );
}
